export class ServicePrmium {
    public id: number;
    public date: Date;
    public markId: number;
    public modelId: number;
    public imei: string;
    public failure: string;
    public conceptId: number;
    public departmentId: number;
    public cityId: number;
    public address: string;
    public addressDesciption: string;
    public identification: string;
    public name: string;
    public email: string;
    public latitude: string;
    public longitude: string;
    public nroTicket: string;
    public entryRepair: string;
    public phone: string;
    public aceptPolicy: boolean;
    public aceptShipping: boolean;
    public city: string;
    public concept: string;
    public mark: string;
    public model: string;
    


    constructor() { }
}